import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../redux/store";
import {
  addTaskLogAction,
  editTaskLogAction,
  fetchTaskLogsAction,
  deleteTaskLogAction,
} from "../redux/actions/taskLogActions";
import { TaskLog } from "../types/TaskLog";
import TaskLogList from "../components/TaskLogList";
import Modal from "../components/Modal";
import CollapseCard from "../components/custom/CollapseCard";
import PageContainer from "../components/custom/PageContainer";
import Main from "../components/custom/Main";

import { StoreState } from "../redux/reducers";
import { useToast } from "../components/toast/ToastProvider";
import TaskLogsForm from "./TaskLogsForm";

const TaskLogPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toast = useToast();

  const taskLogs = useSelector((state: StoreState) => state.taskLog);
  const [selectedLog, setSelectedLog] = useState<TaskLog | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchTaskLogsAction()).finally(() => setLoading(false));
  }, [dispatch]);

  const handleSave = async (data: TaskLog) => {
    setLoading(true);
    try {
      if (selectedLog) {
        await dispatch(editTaskLogAction(data.id, data));
        toast("Task log updated successfully");
      } else {
        await dispatch(addTaskLogAction(data));
        toast("Task log added successfully");
      }
      await dispatch(fetchTaskLogsAction());
      setSelectedLog(null);
      setShowModal(false);
    } catch (error) {
      toast("Error saving task log");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this log?")) {
      setLoading(true);
      try {
        await dispatch(deleteTaskLogAction(id));
        toast("Task log deleted successfully");
        await dispatch(fetchTaskLogsAction());
      } catch (error) {
        toast("Error deleting task log");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleEdit = (item: TaskLog) => {
    setSelectedLog(item);
    setShowModal(true);
  };

  return (
    <Main>
      <PageContainer title="Task Management">
        <button
          className="btn btn-primary mb-3"
          onClick={() => setShowModal(true)}
          disabled={loading}
        >
          {loading ? "Loading..." : "ADD"}
        </button>

        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedLog(null);
          }}
          headerText={selectedLog ? "Update Task Log" : "Add Task Log"}
        >
          <TaskLogsForm initialData={selectedLog} onSave={handleSave} />
        </Modal>

        <CollapseCard title="Task Log List">
          <TaskLogList
            list={taskLogs}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default TaskLogPage;
